<div
  [class.hidden]="!displayBanner() || !addToHomeScreenService.deferredPrompt || (hideBanner$ | async) || isLocal"
  class="fixed bottom-0 left-0 right-0 z-50"
>
  <div
    [attr.browserPromptBtn]="addToHomeScreenService.browserPromptBtn$ | async"
    [attr.iOSSafariHow2]="addToHomeScreenService.iOSSafariHow2$ | async"
    class="flex flex-col p-3 add-to-home-screen"
  >
    <div (click)="onDismiss()" class="close-icon absolute top-0 right-0 p-3">X</div>

    <div class="flex items-center mb-2">
      <img [alt]="title.getTitle()" class="block w-1/8 mr-2" src="./assets/icons/icon-48x48.png" />

      <div class="flex flex-col">
        <p [innerText]="title.getTitle()" class="text-black"></p>

        <p [innerText]="hostname" class="text-black"></p>
      </div>
    </div>

    @if (addToHomeScreenService.iOSSafariHow2$ | async) {
      <div class="flex flex-col text-black">
        <strong class="block">Add a shortcut to your home screen</strong>

        <ol class="list-decimal pl-4">
          <li>
            <div class="flex">
              {{ 'ADD_TO_HOME_SCREEN.IOS.STEP_1_1' | translate }}
              <gan-lucid-icon iconId="share" [iconSize]="15" class="mx-1" />
              {{ 'ADD_TO_HOME_SCREEN.IOS.STEP_1_2' | translate }}
            </div>
          </li>

          <li>
            <div class="flex">
              {{ 'ADD_TO_HOME_SCREEN.IOS.STEP_2' | translate }}
              <gan-lucid-icon iconId="square-plus" [iconSize]="15" class="ml-1" />
              .
            </div>
          </li>
        </ol>
      </div>
    } @else {
      @if (addToHomeScreenService.browserPromptBtn$ | async) {
        <button
          type="button"
          class="bg-blue-500 px-4 py-2 text-white uppercase ml-auto"
          [innerText]="'ADD_TO_HOME_SCREEN.BUTTON' | translate"
          (click)="addToHomeScreenService.addToHomeScreen()"
        ></button>
      }
    }
  </div>
</div>
